(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    initScrollReveal();
    initCardEffects();
    initDrawer();
    initQuickAdd();
  });

  function initScrollReveal() {
    const els = document.querySelectorAll('.lx-sr');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('lx-vis');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    els.forEach(el => io.observe(el));
  }

  function initCardEffects() {
    document.querySelectorAll('.lx-card').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(700px) rotateX(${(-y * 3.5).toFixed(2)}deg) rotateY(${(x * 3.5).toFixed(2)}deg) translateZ(3px)`;
        card.style.transition = 'transform 0.08s ease';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.transition = 'transform 0.6s cubic-bezier(0.22,1,0.36,1)';
      });
      const quick = card.querySelector('.lx-cquick');
      if (quick) {
        card.addEventListener('touchstart', () => { quick.style.transform = 'translateY(0)'; }, { passive: true });
        card.addEventListener('touchend', () => { setTimeout(() => { quick.style.transform = ''; }, 1800); }, { passive: true });
      }
    });
  }

  function initDrawer() {
    const drawer = document.getElementById('lxDrawer');
    const openBtn = document.getElementById('lxHamburger');
    const closeBtn = document.getElementById('lxDrawerClose');
    if (!drawer || !openBtn || !closeBtn) return;
    openBtn.addEventListener('click', () => drawer.classList.add('lx-open'));
    closeBtn.addEventListener('click', () => drawer.classList.remove('lx-open'));
  }

  function initQuickAdd() {
    document.querySelectorAll('.lx-cqbtn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        const original = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error();
          btn.textContent = 'Added ✓';
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          const count = document.querySelector('.lx-cart-count');
          if (count) count.textContent = cartData.item_count;
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2200);
        } catch {
          btn.textContent = 'Error — retry';
          btn.disabled = false;
        }
      });
    });
  }

})();